import React from "react";
import styles from './styles.module.css'
export default function Footer(){
    return(
     <footer className={styles.footer}>
        &copy; 2023 by Subhash Kumar Jaiswal.
    </footer>
    )
}